import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoginData, ScanData } from './interfaces';
import { AuthInfo } from './interfaces/auth-info';
import { AuthorizationService } from './services/authorization.service';
import { ScanService } from './services/scan.service';
import { UserService } from './services/user.service';
import { LoginDialogComponent } from './views';
import { TimeData, TimeTravelDialogComponent } from './views/time-travel-dialog/time-travel-dialog.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  userInfo?: AuthInfo;

  username = '';

  time = Date.parse('2022-12-08T14:00');

  data: ScanData = { url: '' };

  private userColors: { [key: string]: string } = {
    'GHA': 'gha-user',
    'Forwarder': 'forwarder-user',
    'CHA': 'cha-user',
    '': 'no-user'
  };

  constructor(public userService: UserService, public authService: AuthorizationService,
    private scanService: ScanService, private dialog: MatDialog, private router: Router) {
    this.userService.subscribe((user) => this.updateUser(user));
    this.updateUser(this.userService.currentUser());
  }

  logout() {
    this.userService.logout();
    this.username = '';
    this.router.navigate(['/']);

  }

  login(text: string = 'Login') {
    if (!this.userService.loggedIn()) {
      const data: LoginData = { username: '', password: '', text: text };
      const dialogRef = this.dialog.open(LoginDialogComponent, { width: '320px', disableClose: true, data: data });

      dialogRef.afterClosed().subscribe((data: LoginData) => {
        this.userService.login(data).subscribe(
          {
            next: (res) => {
              console.log('login result', res);
            },
            error: (e) => {
              this.login('Login failed!');
              console.log('error:', e)
            }
          });
      });
    }
  }

  navigate(mask: string) {
    this.scanService.setMask(mask);
  }



  timeTravel() {
    const dialogRef = this.dialog.open(TimeTravelDialogComponent, { width: '80%', disableClose: false, data: { time: this.time } });
    dialogRef.afterClosed().subscribe((data: TimeData) => {
      console.log('datatime', data.time.valueOf());
      this.time = data.time.valueOf();
    });
  }

  updateUser(user?: AuthInfo) {
    if (user) {
      this.username = `${user.username}`;
    }
    this.userInfo = user;

  }

  scan() {
    this.scanService.doScan();
  }

  userClass(): string {
    return this.userColors[this.userService.currentUser()?.username ?? ''] ?? this.userColors[''];
  }

}
